import './BrandShowcase.less';

export const BrandShowcase = () => {
  return (
    <div className="flex w-[49%] flex-col items-center justify-center border border-white bg-[#F3F3F3]">
      <div className="brand-show-case relative h-[500px] w-[556px] rounded-[32px] from-[#ffffff66] to-[#ffffff29] bg-cover bg-center bg-no-repeat px-[73px] py-[41px]" />
    </div>
  );
};
